<fury-page>
    <fury-title class="title">
      <span [@fadeInRight]>Dashboard</span>
    </fury-title>
</fury-page>

<fury-page [fxLayoutGap]="gap" class="dashboard" fxLayout="column">

    
      <div fxLayout="column" fxLayoutAlign="center center">
        <div class="dashboardbody">
            <div class="innerdashbody">
                <mat-tab-group animationDuration="0ms">
                    <mat-tab label="Leads">
                        <ul class="listcont">
                            <li>
                                New Leads
                                <span class="green">{{dashboardDetails?.newLeads | number}}</span>
                            </li>
                            <li>
                                Active Leads
                                <span class="green">{{dashboardDetails?.activeLeads | number}}</span>
                            </li>
                            <li>
                                Closed Leads
                                <span class="red">{{dashboardDetails?.closedLeads | number}}</span>
                            </li>
                            <li>
                                Bad Leads
                                <span class="red">{{dashboardDetails?.badLeads | number}}</span>
                            </li>
                            <li>
                                Not Covered Leads
                                <span class="red">{{dashboardDetails?.notCoveredLeads | number}}</span>
                            </li>
                            <li>
                                Duplicate Leads
                                <span class="orenge">{{dashboardDetails?.duplicateLeads | number}}</span>
                            </li>
                            <li>
                                Valid Leads
                                <span class="orenge">{{dashboardDetails?.validLeads | number}}</span>
                            </li>
                            <li>
                                Total Leads
                                <span class="orenge">{{dashboardDetails?.totalLeads | number}}</span>
                            </li>
                            <li>
                                CPA
                                <span class="orenge">$ {{dashboardDetails?.cpa | number}}</span>
                            </li>
                            <li>
                                Sales
                                <span class="orenge">{{dashboardDetails?.sales | number}}</span>
                            </li>
                            <li>
                                Conversion
                                <span class="orenge">{{dashboardDetails?.conversion | number}} %</span>
                            </li>
                            <li>
                                Leads Cost
                                <span class="blue">$ {{dashboardDetails?.leadCost | number}}</span>
                            </li>
                        </ul>
                    </mat-tab>
                    <mat-tab label="Security">
                        <ul class="listcont">
                            <li>
                                Active Leads
                                <span class="green">{{dashboardDetails?.activeLeads | number}}</span>
                            </li>
                            <li>
                                Error Leads
                                <span class="red">{{dashboardDetails?.badLeads | number}}</span>
                            </li>
                            <li>
                                Dup leads
                                <span class="orenge">{{dashboardDetails?.duplicateLeads | number}}</span>
                            </li>
                            <li>
                                Stuck Leads
                                <span class="blue">{{dashboardDetails?.stuckLeads | number}}</span>
                            </li>
                          
                        </ul>
                    </mat-tab>
                </mat-tab-group>
                <div class="rangeselectorprt">
                    <form [formGroup]="selectType">
                        <span>
                                <input type="radio" value="hourType" formControlName="type"/>
                               
                                <mat-form-field appearance="outline">
                                    <mat-label>Select Duration</mat-label>
                                    <mat-select formControlName="hourValue" [disabled]="selectType.value.type !== 'hourType'" (selectionChange)="hourRangeChange($event)">
                                        <mat-option *ngFor="let hour of hours" [value]="hour.value">
                                            {{hour.viewValue}}
                                          </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </span>
                            <span>
                                <input type="radio" value="dateType" formControlName="type"/>
                                <div class="daterange">
                                    <mat-form-field class="example-form-field" appearance="outline">
                                    <mat-label>Date Range</mat-label>
                                        <mat-date-range-input
                                        [formGroup]="campaignOne"
                                        [rangePicker]="campaignOnePicker"
                                        [max]="today" 
                                        [disabled]="selectType.value.type !== 'dateType'">
                                        <input matStartDate placeholder="Start date" formControlName="start" #dateRangeStart>
                                        <input matEndDate placeholder="End date" formControlName="end" #dateRangeEnd (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                                        </mat-date-range-input>
                                        <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                                        <mat-datepicker-toggle matIconSuffix [for]="campaignOnePicker"></mat-datepicker-toggle>
                                        <mat-date-range-picker #campaignOnePicker>
                                            <mat-date-range-picker-actions>
                                                <button class="apply" mat-raised-button color="primary" matDateRangePickerApply>Apply</button>
                                                <button class="can" mat-button matDateRangePickerCancel>Cancel</button>
                                            </mat-date-range-picker-actions>
                                        </mat-date-range-picker>
                                    </mat-form-field>
                                </div>
                            </span>
                    </form>
                </div>
               
            </div>
        </div>
      </div>
       
   
</fury-page>




